<template>
  <header id="site-header">
    <figure class="logo">
      <a href="./">
        <img src="https://cospanic.webkid.work/audition/images/idol-entry/logo_l.webp" alt="ME2U" />
      </a>
    </figure>
    <nav>
      <ul>
        <li><a href="#app">Top</a></li>
        <li><a href="#concept">Concept</a></li>
        <li><a href="#requirements">Requirements</a></li>
        <li><a href="#process">Process</a></li>
        <li><a href="#method">Method</a></li>
      </ul>
    </nav>
    <div class="contact">
      <a href="#entry">エントリーはこちら</a>
    </div>
  </header>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 1rem side();
  background: rgba($black,.72);
  backdrop-filter: saturate(90%) blur(20px);
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  > *{
    align-self: center;
  }
  .logo{
    width: 4rem;
    justify-self: flex-start;
    @media screen and (max-width: $phone){
      display: none;
    }
    img{
      width: 100%;
    }
  }
  nav{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ul{
      @include flex();
      align-items: center;
      justify-content: center;
      @media screen and (max-width: $phone){
        display: none;
      }
      li{
        line-height: 1;
        margin: 0 0 0 2.4rem;
        @media screen and (max-width: $tab){
          &:nth-child(1){
            display: none;
          }
          &:nth-child(2){
            display: none;
          }
          &:nth-child(3){
            margin-left: 0;
          }
        }
        &:first-child{
          margin-left: 0;
        }
        a{
          text-transform: uppercase;
          font-size: 1.04rem;
          color: $dark;
          fill: $normal;
          display: inline-flex;
          align-items: center;
          position: relative;
          padding: .4rem;
          z-index: 1;
          &:hover{
            color: $white;
            fill: $dark;
          }
          svg{
            width: 7.2vmin;
            height: 7.2vmin;
            display: inline-block;
            margin: 0 0 0 .8vmin;
          }
        }
      }
    }
  }
  .contact{
    justify-self: flex-end;
    a{
      border: $dark 1px solid;
      color: $dark;
      padding: .4rem 1.6rem;
      font-size: .92rem;
      display: block;
      position: relative;
      z-index: 2;
      transition: all 200ms $ease;
      &:before{
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 100%;
        background: $white;
        z-index: -1;
        transition: width 200ms $ease;
      }
      &:hover{
        border-color: $white;
        color: $black;
        &:before{
          width: 100%;
          right: auto;
          left: 0;
        }
      }
    }
  }
}
</style>

<script>
export default {
  data: function(){
    return {
      trg: false
    }
  }
}
</script>
